import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ProfileInsights.module.css';
import { ProfileViewsUI } from '../../../components/UI/Common/ProfileViews/ProfileViewsUI';
import { EmployerStats } from '../../../components/UI/Common/EmployerStats/EmployerStats';
import { EmployerList } from '../../../components/UI/Common/EmployerList/EmployerList';
import { useSelector } from 'react-redux';
import GlobalModal from '../../../components/UI/Popups/GlobalModal/GlobalModal';
import { useNavigate } from 'react-router-dom';

function ProfileViews() {
    const { t } = useTranslation(); // Hook for translations
    const user = useSelector(state => state.user.user);
    const [showVerificationModal, setShowVerificationModal] = useState(false);
    const [isVerified, setIsVerified] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        // Check if user is not verified
        if (user && user.verification_status !== 'approved') {
            setShowVerificationModal(true);
            setIsVerified(false);
        } else {
            setIsVerified(true);
        }
    }, [user]);

    const handleVerifyNow = () => {
        navigate('/profile/verification');
        setShowVerificationModal(false);
    };

    const handleCancelVerification = () => {
        setShowVerificationModal(false);
        navigate('/profile');
    };

    return (
        <div className={styles.profileViewsContainer}>
            <div className={`${styles.contentOverlay}`}>
                <div className={`${styles.wrapper} ${!isVerified ? styles.blurredContent : ''}`}>
                    <p className={styles.mainHeading}>{t('profileInsights')}</p>
                    <ProfileViewsUI />
                    <EmployerStats />
                    <EmployerList />
                </div>
            </div>

            <GlobalModal
                show={showVerificationModal}
                onClose={handleCancelVerification}
                title={t('forms.verification.required')}
                message={t('forms.verification.insightsRequireVerification')}
                primaryButtonText={t('forms.verification.verifyNow')}
                secondaryButtonText={t('general.UI.cancel')}
                primaryButtonAction={handleVerifyNow}
                secondaryButtonAction={handleCancelVerification}
            />
        </div>
    );
}

export default ProfileViews;
